import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("dp_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => localStorage.removeItem("dp_token"))
      .finally(() => setLoading(false));
  }, []);

  const persist = (token, u) => {
    localStorage.setItem("dp_token", token);
    setUser(u);
  };

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    persist(res.data.token, res.data.user);
    return res.data.user;
  };

  const loginAsVisitor = async () => {
    const res = await api.post("/auth/visitor-login");
    persist(res.data.token, res.data.user);
    return res.data.user;
  };

  const signup = async (payload) => {
    const res = await api.post("/auth/signup", payload);
    persist(res.data.token, res.data.user);
    return res.data.user;
  };

  const updateUser = (updatedUser) => {
    setUser((currentUser) => ({ ...currentUser, ...updatedUser }));
  };

  const logout = () => {
    localStorage.removeItem("dp_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, loginAsVisitor, signup, updateUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
